import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { DrawerService } from "src/app/services/drawer.service";
import { FabButtonService } from "src/app/services/fab-button.service";
import { LayoutsService } from "../../../services/layouts.service";
import { CampanaCalendarComponent } from './calendar/calendar.component';
import { CampanaService } from "./campana.service";
import { CampanaForm } from "./form/form.component";

interface DayUnits {
  text: string;
  units: string[];
}

@Component({
  selector: "app-campana",
  templateUrl: "./campana.component.html",
  styles: [],
})
export class CampanaComponent implements OnInit, OnDestroy {
  form: any;

  @ViewChild("calendarComp") calendarComp: CampanaCalendarComponent;
  constructor(
    public service: CampanaService,
    public layService: LayoutsService,
    public spinner: NgxSpinnerService,
    private drawer: DrawerService,
    public fab: FabButtonService,
    private serv: CampanaService,
    private alerts: AlertasSwalService,
  ) {
    this.layService.changeHeader("Campanas de mantenimiento");
  }

  daysMonth: DayUnits[] = [];

  btnAgregar = {
    backgroundClass: "bg-blue-500 hover:w-52",
    iconClass: "fa fa-calendar-plus",
    title: "Agregar campaña",
    action: () => {
      this.addCampana();
    },
  };
  ngOnInit(): void {
    this.fab.addButton(this.btnAgregar);
  }
  ngOnDestroy(): void {
    this.fab.removeButton(this.btnAgregar);
  }

  addCampana() {
    const drawerRef = this.drawer.open({
      component: CampanaForm,
      data: { mode: "create", value: {} },
      width: "500px",
      title: "Nueva campaña",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {

      this.serv.add(result.data).subscribe(
        (next) => {
          this.alerts.correcta("Creado", "Accion realizada correctamente");
          this.calendarComp.drawCalendar();
        },
        (err) => {
          this.alerts.error("error", err.error.Message);
        },
      );
    });
  }
}
